/*
 * Chat Messages
 *
 * This contains all the text for the Chat components.
 */
import { defineMessages } from 'react-intl'

export default defineMessages({
  subheader: {
    id: 'covert.containers.address.subheader',
  },
  legal: {
    id: 'covert.containers.address.legal',
  },
  addressLine1: {
    id: 'covert.containers.address.field.AddressLine1',
    sid: 'addressLine1',
  },
  addressLine1ValidationEmpty: {
    id: 'covert.containers.address.field.AddressLine1.addressLine1ValidationEmpty',
  },
  addressLine1LengthValidation: {
    id: 'covert.containers.address.field.AddressLine1.addressLine1LengthValidation',
  },
  addressLine2: {
    id: 'covert.containers.address.field.AddressLine2',
    sid: 'addressLine2',
  },
  addressLine2LengthValidation: {
    id: 'covert.containers.address.field.AddressLine2.addressLine2LengthValidation',
  },
  addressLine2Hint: {
    id: 'covert.containers.address.field.AddressLine2.hint',
  },
  city: {
    id: 'covert.containers.address.field.city',
    sid: 'addressLine3',
  },
  cityLengthValidation: {
    id: 'covert.containers.address.field.city.cityLengthValidation',
  },
  cityValidationEmpty: {
    id: 'covert.containers.address.field.city.cityValidationEmpty',
  },
  country: {
    id: 'covert.containers.address.field.country',
    sid: 'country',
  },
  province: {
    id: 'covert.containers.address.field.province',
    sid: 'province',
  },
  provinceSelectList: {
    id: 'covert.containers.address.field.province.options',
    sid: 'provinceSelectList',
  },
  provinceSelectListValidationEmpty: {
    id: 'covert.containers.address.field.province.provinceSelectListValidationEmpty',
  },
  postalCode: {
    id: 'covert.containers.address.field.postalCode',
    sid: 'postalCode',
  },
  postalCodeValidationEmpty: {
    id: 'covert.containers.address.field.postalCode.postalCodeValidationEmpty',
    sid: 'postalCode',
  },
  postalCodeValidationInvalid: {
    id: 'covert.containers.address.field.postalCode.postalCodeValidationInvalid',
    sid: 'postalCode',
  },
  cta: {
    id: 'covert.containers.address.field.cta',
    sid: 'cta',
  },
})



// WEBPACK FOOTER //
// ./src/containers/Cart/Address/messages.js